import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button, Card, CardMedia, Grid } from '@mui/material'

import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useStore } from '../../../state/MobxContext';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";


function CloverMarketCategoryBar(props) {


  const { SaleStore } = useStore();


  const useStyles = makeStyles((theme) => ({
    //BrandImage
    BrandImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '100%',
      height: "auto"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));

  const classes = useStyles();

  // const items = {
  //   img: "dd",
  // }

  let items = toJS(SaleStore.BrandTable);

  const breakPoints = [
    {width: 320, itemsToShow: 3},
    {width: 600, itemsToShow: 3},
    {width: 800, itemsToShow: 3},
    {width: 1200, itemsToShow: 3},

  ]
  let BrandChack = String(SaleStore.market_category);

  // console.log(BrandChack);


  return (
    
    <Carousel
    autoPlay={true}
    indicators={true}
    swipe={true}
    navButtonsAlwaysVisible={true}
    breakPoints={breakPoints}
    sx={{px: "5%"}}
    >
      {
        items.map((item, i) => 
        // item.Category === BrandChack &&
        <Item key={i} item={item} />
        )
      }
    </Carousel>
  )
}

export default observer(CloverMarketCategoryBar);

function Item(props) {


  const useStyles = makeStyles((theme) => ({
    //BrandImage
    BrandImage: {
      // whiteSpace: "nowrap",
      // objectFit: "cover",
      width: '10rem',
      height: "8rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));

  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");


  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
  })(Typography);

  // console.log("Prrr", props);
  return (
    <Card key={props.item.Index}
      sx={ isMobile ? { bgcolor: "black", maxWidth: 50, } : { bgcolor: "black", maxWidth: 180, }} >
      {/* <Box sx={{ boxShadow: 5, bgcolor: "black" }}> */}
      {/* <img src={props.item.image} alt={props.item.Brand} className={classes.BrandImage} /> */}
      <CardMedia
        component="img"
        sx={isMobile ? { height: 50 } :{ height: 120 }}
        image={props.item.image}
        alt={props.item.Brand}
      />
      <Grid container direction='row' justifyContent='center' alignItems='center' >
        <BrandTypographyMobile>
          {props.item.Brand}
        </BrandTypographyMobile>
      </Grid>
      {/* </Box> */}
      {/* <p>{props.item.description}</p> */}
      {/* <Button className="CheckButton">
        Check it out!
      </Button> */}
    </Card>
  )
}